import template from './index.pug'
import AiInfinityRuleForm from '../components/_form.js'

export default Vue.extend({
  template: template(),
  components: {
    AiInfinityRuleForm
  },
  data() {
    return {
      ready: false,
      ruleData: {}
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    t(key) {
      return this.$t(`aiInfinityRules.edit.${key}`);
    },
    fetchData() {
      const id = this.$route.params.id;

      API.aiInfinityRules.index()
        .then(({data}) => {
          this.ruleData = (data || []).find(rule => rule.id === id) || {};
          this.ready = true;
        })
        .catch(error => {
          console.error('Error al cargar la regla:', error);
          this.$notifications.error(this.t('loadError'));
          this.$router.push({ name: 'ai-infinity-rules-list' });
        });
    }
  }
})